const GMapUtils = {

    fitMarkersInMapBounds: (map, markers) => {
        var bounds = new window.google.maps.LatLngBounds();
        
        markers.forEach((marker) => {
            bounds.extend(new window.google.maps.LatLng(marker.position.lat, marker.position.lng));
        })

        map.fitBounds(bounds);
        map.setCenter(bounds.getCenter());
    },

    drawCircleAroundMarker :(marker,map) =>{
        const markerCircle = new window.google.maps.Circle({
            strokeColor: '#FF0000', // Red outline
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000', // Red fill
            fillOpacity: 0.35,
            map: map,
            center: marker.getPosition(), // Center the circle on the marker's position
            radius: 5000 // Radius in meters (e.g., 5000 meters = 5 km)
        });

        return markerCircle;
    }
}
export default GMapUtils;